/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentMetricSummaryDto
 */
export interface DeploymentMetricSummaryDto {
    /**
     * The display label of the summary.
     * @type {string}
     * @memberof DeploymentMetricSummaryDto
     */
    label: string;
    /**
     * How the values are aggregated.
     * @type {string}
     * @memberof DeploymentMetricSummaryDto
     */
    type: DeploymentMetricSummaryDtoTypeEnum;
    /**
     * The mapping prefix that the summary is based on.
     * @type {string}
     * @memberof DeploymentMetricSummaryDto
     */
    prefix: string;
    /**
     * The optional value name to select a single value under the prefix.
     * @type {string}
     * @memberof DeploymentMetricSummaryDto
     */
    value: string | null;
}


/**
 * @export
 */
export const DeploymentMetricSummaryDtoTypeEnum = {
    Avg: 'avg',
    Max: 'max'
} as const;
export type DeploymentMetricSummaryDtoTypeEnum = typeof DeploymentMetricSummaryDtoTypeEnum[keyof typeof DeploymentMetricSummaryDtoTypeEnum];


/**
 * Check if a given object implements the DeploymentMetricSummaryDto interface.
 */
export function instanceOfDeploymentMetricSummaryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "prefix" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function DeploymentMetricSummaryDtoFromJSON(json: any): DeploymentMetricSummaryDto {
    return DeploymentMetricSummaryDtoFromJSONTyped(json, false);
}

export function DeploymentMetricSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentMetricSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'type': json['type'],
        'prefix': json['prefix'],
        'value': json['value'],
    };
}

export function DeploymentMetricSummaryDtoToJSON(value?: DeploymentMetricSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'type': value.type,
        'prefix': value.prefix,
        'value': value.value,
    };
}

